import api from './authAPI';

export const platformAPI = {
  bootstrap: () => api.get('/parivartan/bootstrap'),
  workspaceSummary: () => api.get('/parivartan/workspace/summary'),
  roleDashboard: () => api.get('/parivartan/dashboard'),
  myWorkItems: (params) => api.get('/parivartan/work-items/mine', { params }),
  updateWorkItemStatus: (id, status) => api.patch(`/parivartan/work-items/${id}/status`, { status }),

  getOnboarding: () => api.get('/parivartan/onboarding'),
  saveOnboardingStep: (step, payload) => api.post('/parivartan/onboarding/step', { step, payload }),
  activateOnboarding: () => api.post('/parivartan/onboarding/activate'),
  upsertLocation: (body) => api.post('/parivartan/locations', body),
  upsertDepartment: (body) => api.post('/parivartan/departments', body),
  listLocations: () => api.get('/parivartan/locations'),
  listDepartments: () => api.get('/parivartan/departments'),

  listUsers: (params) => api.get('/parivartan/users', { params }),
  loginHistory: () => api.get('/parivartan/users/login-history'),
  getUser: (id) => api.get(`/parivartan/users/${id}`),
  listTenderTeam: () => api.get('/parivartan/tender-team'),
  createUser: (body) => api.post('/parivartan/users', body),
  updateUser: (id, body) => api.put(`/parivartan/users/${id}`, body),
  deleteUser: (id) => api.delete(`/parivartan/users/${id}`),
  deleteRecords: (body) => api.post('/parivartan/admin/records/delete', body),
  listMasterRevisions: (params) => api.get('/parivartan/masters/revisions', { params }),
  getUserPermissions: (id) => api.get(`/parivartan/users/${id}/permissions`),
  listRolesCatalog: () => api.get('/parivartan/roles/catalog'),
  upsertRoleTemplate: (body) => api.post('/parivartan/roles/templates', body),
  resetRoleTemplate: (body) => api.post('/parivartan/roles/templates/reset', body),
  deleteRoleTemplate: (key) => api.delete(`/parivartan/roles/templates/${key}`),

  getCompany: () => api.get('/parivartan/company'),
  updateCompany: (body) => api.put('/parivartan/company', body),
  getOrganisation: (params) => api.get('/parivartan/settings/organisation', { params }),
  updateOrganisation: (body) => api.put('/parivartan/settings/organisation', body, { skipToast: true }),
  publicBranding: (code) => api.get(`/parivartan/branding/${encodeURIComponent(code)}`, { skipToast: true }),
  uploadOrganisationLogo: (file) => {
    const body = new FormData();
    body.append('logo', file);
    return api.post('/parivartan/settings/organisation/logo', body, {
      skipToast: true,
      transformRequest: [(data, headers) => {
        delete headers['Content-Type'];
        return data;
      }]
    });
  },
  clearOrganisationLogo: () => api.delete('/parivartan/settings/organisation/logo', { skipToast: true }),
  listTurnover: () => api.get('/parivartan/company/turnover'),
  saveTurnover: (body) => api.post('/parivartan/company/turnover', body, { skipToast: true }),
  updateTurnover: (id, body) => api.put(`/parivartan/company/turnover/${id}`, body, { skipToast: true }),
  deactivateTurnover: (id) => api.post(`/parivartan/company/turnover/${id}/deactivate`, {}, { skipToast: true }),
  getAiConfig: () => api.get('/parivartan/ai-config'),
  updateAiConfig: (body) => api.put('/parivartan/ai-config', body),
  testAiConfig: (body) => api.post('/parivartan/ai-config/test', body || {}),
  listAudit: (params) => api.get('/parivartan/audit', { params }),
  exportAudit: (params) => api.get('/parivartan/audit/export', { params, responseType: 'blob' }),
  listApplications: () => api.get('/parivartan/applications'),
  listApprovalQueue: (params) => api.get('/parivartan/approvals/queue', { params }),
  getApproval: (id) => api.get(`/parivartan/approvals/work-items/${id}`),
  approvalAction: (id, body) => api.post(`/parivartan/approvals/work-items/${id}/action`, body),
  listMasters: (type) => api.get('/parivartan/masters', { params: { type } }),
  lookupMasters: () => api.get('/parivartan/masters/lookup'),
  listReference: (catalog, params) => api.get(`/parivartan/masters/reference/${catalog}`, { params }),
  listDiligenceTemplates: () => api.get('/parivartan/masters/diligence-templates'),
  getDiligenceTemplate: (id) => api.get(`/parivartan/masters/diligence-templates/${id}`),
  saveDiligenceTemplate: (body) => api.post('/parivartan/masters/diligence-templates', body, { skipToast: true }),
  listDropdownCatalogs: () => api.get('/parivartan/settings/dropdowns'),
  listDropdownValues: (catalog) => api.get(`/parivartan/settings/dropdowns/${catalog}`),
  getDropdownValue: (catalog, id) => api.get(`/parivartan/settings/dropdowns/${catalog}/${id}`),
  createDropdownValue: (catalog, body) => api.post(`/parivartan/settings/dropdowns/${catalog}`, body, { skipToast: true }),
  updateDropdownValue: (catalog, id, body) => api.put(`/parivartan/settings/dropdowns/${catalog}/${id}`, body, { skipToast: true }),
  deleteDropdownValue: (catalog, id) => api.delete(`/parivartan/settings/dropdowns/${catalog}/${id}`, { skipToast: true }),
  getMailSettings: () => api.get('/parivartan/settings/mail'),
  updateMailSettings: (body) => api.put('/parivartan/settings/mail', body, { skipToast: true }),
  testMailSettings: (body) => api.post('/parivartan/settings/mail/test', body || {}, { skipToast: true }),
  importMasterRows: (type, rows, mode = 'create') => api.post('/parivartan/masters/upload', { type, rows, mode }, { skipToast: true }),
  listCustomers: () => api.get('/parivartan/masters/customers'),
  getCustomer: (id) => api.get(`/parivartan/masters/customers/${id}`),
  createCustomer: (body) => api.post('/parivartan/masters/customers', body),
  updateCustomer: (id, body) => api.put(`/parivartan/masters/customers/${id}`, body),
  deleteCustomer: (id) => api.delete(`/parivartan/masters/customers/${id}`),
  listServices: () => api.get('/parivartan/masters/services'),
  getService: (id) => api.get(`/parivartan/masters/services/${id}`),
  createService: (body) => api.post('/parivartan/masters/services', body),
  updateService: (id, body) => api.put(`/parivartan/masters/services/${id}`, body),
  deleteService: (id) => api.delete(`/parivartan/masters/services/${id}`),
  listSectors: () => api.get('/parivartan/masters/sectors'),
  getSector: (id) => api.get(`/parivartan/masters/sectors/${id}`),
  createSector: (body) => api.post('/parivartan/masters/sectors', body),
  updateSector: (id, body) => api.put(`/parivartan/masters/sectors/${id}`, body),
  deleteSector: (id) => api.delete(`/parivartan/masters/sectors/${id}`),
  listTenderTypes: () => api.get('/parivartan/masters/tender-types'),
  getTenderType: (id) => api.get(`/parivartan/masters/tender-types/${id}`),
  createTenderType: (body) => api.post('/parivartan/masters/tender-types', body),
  updateTenderType: (id, body) => api.put(`/parivartan/masters/tender-types/${id}`, body),
  deleteTenderType: (id) => api.delete(`/parivartan/masters/tender-types/${id}`),
  listSources: () => api.get('/parivartan/masters/sources'),
  getSource: (id) => api.get(`/parivartan/masters/sources/${id}`),
  createSource: (body) => api.post('/parivartan/masters/sources', body),
  updateSource: (id, body) => api.put(`/parivartan/masters/sources/${id}`, body),
  deleteSource: (id) => api.delete(`/parivartan/masters/sources/${id}`),

  getSupportStats: () => api.get('/parivartan/support/stats'),
  listSupportTickets: (params) => api.get('/parivartan/support/tickets', { params }),
  getSupportTicket: (id) => api.get(`/parivartan/support/tickets/${id}`),
  createSupportTicket: (body) => {
    if (body instanceof FormData) {
      return api.post('/parivartan/support/tickets', body, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
    return api.post('/parivartan/support/tickets', body);
  },

  listCostEstimates: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/cost-estimates`),
  createCostEstimate: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/cost-estimates`, body, { skipToast: true }),
  updateCostEstimate: (id, body) => api.put(`/parivartan/cost-estimates/${id}`, body, { skipToast: true }),
  submitCostEstimate: (id, body) => api.post(`/parivartan/cost-estimates/${id}/submit`, body, { skipToast: true }),
  approveCostEstimate: (id, body) => api.post(`/parivartan/cost-estimates/${id}/approve`, body, { skipToast: true }),
  returnCostEstimate: (id, body) => api.post(`/parivartan/cost-estimates/${id}/return`, body, { skipToast: true }),
  saveFinancialOffer: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/financial-offers`, body, { skipToast: true }),
  confirmFinancialOffer: (id) => api.post(`/parivartan/financial-offers/${id}/confirm`, {}, { skipToast: true }),

  listRates: () => api.get('/parivartan/rates'),
  getRate: (id) => api.get(`/parivartan/rates/${id}`),
  upsertRate: (body) => api.post('/parivartan/rates', body),
  deactivateRate: (id) => api.post(`/parivartan/rates/${id}/deactivate`),

  listTimesheets: (params) => api.get('/parivartan/timesheets', { params }),
  getTimesheet: (id) => api.get(`/parivartan/timesheets/${id}`),
  timesheetMeta: () => api.get('/parivartan/timesheets/meta'),
  previewTimesheetApprover: (params) => api.get('/parivartan/timesheets/approver', { params }),
  createTimesheet: (body) => api.post('/parivartan/timesheets', body, { skipToast: true }),
  submitTimesheet: (id, body) => api.post(`/parivartan/timesheets/${id}/submit`, body || {}, { skipToast: true }),
  approveTimesheet: (id, body) => api.post(`/parivartan/timesheets/${id}/approve`, body, { skipToast: true }),
  returnTimesheet: (id, body) => api.post(`/parivartan/timesheets/${id}/return`, body, { skipToast: true }),
  reopenTimesheet: (id, body) => api.post(`/parivartan/timesheets/${id}/reopen`, body, { skipToast: true }),
  updateTimesheet: (id, body) => api.put(`/parivartan/timesheets/${id}`, body, { skipToast: true }),
  saveTimesheetWeek: (body) => api.post('/parivartan/timesheets/week', body, { skipToast: true }),
  bulkReviewTimesheets: (body) => api.post('/parivartan/timesheets/bulk', body, { skipToast: true }),
  timesheetReport: () => api.get('/parivartan/timesheets/report'),
  exportTimesheetReport: () => api.get('/parivartan/timesheets/report.csv', { responseType: 'blob' }),
  getTimesheetSettings: () => api.get('/parivartan/settings/timesheet'),
  updateTimesheetSettings: (body) => api.put('/parivartan/settings/timesheet', body, { skipToast: true }),
  listTimesheetActivities: () => api.get('/parivartan/masters/timesheet-activities'),
  saveTimesheetActivity: (body) => api.post('/parivartan/masters/timesheet-activities', body, { skipToast: true }),
  listSecurityIssuers: () => api.get('/parivartan/security-issuers'),
  saveSecurityIssuer: (body) => api.post('/parivartan/security-issuers', body, { skipToast: true }),
  listSecurities: (params) => api.get('/parivartan/securities', { params }),
  saveSecurity: (body) => api.post('/parivartan/securities', body, { skipToast: true }),
  extendSecurity: (id, body) => api.post(`/parivartan/securities/${id}/extend`, body, { skipToast: true }),
  releaseSecurity: (id, body) => api.post(`/parivartan/securities/${id}/release`, body, { skipToast: true }),
  markSecurity: (id, body) => api.post(`/parivartan/securities/${id}/status`, body, { skipToast: true }),
  exportSecurities: () => api.get('/parivartan/securities/report.csv', { responseType: 'blob' }),
  listPartners: () => api.get('/parivartan/partners'),
  savePartner: (body) => api.post('/parivartan/partners', body, { skipToast: true }),
  listTenderPartners: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/partners`),
  addTenderPartner: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/partners`, body, { skipToast: true }),
  reviewTenderPartner: (id, body) => api.post(`/parivartan/tender-partners/${id}/review`, body, { skipToast: true }),
  listPreBidQueries: (params) => api.get('/parivartan/pre-bid-queries', { params }),
  savePreBidQuery: (body) => api.post('/parivartan/pre-bid-queries', body, { skipToast: true }),
  listCorrigenda: (params) => api.get('/parivartan/corrigenda', { params }),
  saveCorrigendum: (body) => api.post('/parivartan/corrigenda', body, { skipToast: true }),
  confirmCorrigendumDeadline: (id) => api.post(`/parivartan/corrigenda/${id}/confirm-deadline`, {}, { skipToast: true }),
  listDecisionProfiles: () => api.get('/parivartan/decision-profiles'),
  saveDecisionProfile: (body) => api.post('/parivartan/decision-profiles', body, { skipToast: true }),
  getTenderAssessment: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/assessment`),
  saveTenderAssessment: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/assessment`, body, { skipToast: true }),
  submitTenderAssessment: (id) => api.post(`/parivartan/assessments/${id}/submit`, {}, { skipToast: true }),
  returnTenderAssessment: (id, body) => api.post(`/parivartan/assessments/${id}/return`, body, { skipToast: true }),
  approveTenderAssessment: (id, body) => api.post(`/parivartan/assessments/${id}/approve`, body, { skipToast: true }),
  getPursuitSettings: () => api.get('/parivartan/settings/pursuit'),
  updatePursuitSettings: (body) => api.put('/parivartan/settings/pursuit', body, { skipToast: true }),
  listAssignments: () => api.get('/parivartan/assignments'),
  updateAssignment: (id, body) => api.patch(`/parivartan/assignments/${id}`, body),

  listKnowledge: () => api.get('/parivartan/knowledge'),
  listTenderCredentials: (tenderId) => api.get(
    tenderId
      ? `/parivartan/tenders/${tenderId}/credentials`
      : '/parivartan/knowledge/tender-credentials'
  ),
  attachTenderCredentials: (body) => api.post('/parivartan/knowledge/tender-credentials', body),
  pinTenderCredential: (id, body) => api.post(`/parivartan/knowledge/tender-credentials/${id}/pin`, body || {}),
  detachTenderCredential: (id) => api.delete(`/parivartan/knowledge/tender-credentials/${id}`),
  upsertCredential: (body) => api.post('/parivartan/knowledge/credentials', body),
  getCredential: (id) => api.get(`/parivartan/knowledge/credentials/${id}`),
  upsertProject: (body) => api.post('/parivartan/knowledge/projects', body),
  getProject: (id) => api.get(`/parivartan/knowledge/projects/${id}`),
  upsertReusable: (body) => api.post('/parivartan/knowledge/reusable', body),
  getReusable: (id) => api.get(`/parivartan/knowledge/reusable/${id}`),

  listPersonnel: (params) => api.get('/parivartan/personnel', { params }),
  getPersonnel: (id) => api.get(`/parivartan/personnel/${id}`),
  upsertPersonnel: (body) => api.post('/parivartan/personnel', body),
  listPersonnelProposals: (tenderId) => api.get(
    tenderId
      ? `/parivartan/tenders/${tenderId}/personnel-proposals`
      : '/parivartan/personnel/proposals'
  ),
  attachPersonnelToTenders: (body) => api.post('/parivartan/personnel/proposals', body),
  pinPersonnelProposal: (id, body) => api.post(`/parivartan/personnel/proposals/${id}/pin`, body || {}),
  detachPersonnelProposal: (id) => api.delete(`/parivartan/personnel/proposals/${id}`),

  listEligibility: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/eligibility`),
  upsertEligibility: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/eligibility`, body),
  deleteEligibility: (tenderId, id) => api.delete(`/parivartan/tenders/${tenderId}/eligibility/${id}`),
  getDecision: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/decision`),
  setDecision: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/decision`, body),

  listTechnicalSections: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/technical-sections`),
  upsertTechnicalSection: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/technical-sections`, body),
  deleteTechnicalSection: (tenderId, sectionId) =>
    api.delete(`/parivartan/tenders/${tenderId}/technical-sections/${sectionId}`),
  applyReusableToSection: (tenderId, body) =>
    api.post(`/parivartan/tenders/${tenderId}/technical-sections/apply-reusable`, body),
  draftTechnicalSection: (tenderId, body) =>
    api.post(`/parivartan/tenders/${tenderId}/technical-sections/draft`, body),
  suggestEligibilityNote: (tenderId, body) =>
    api.post(`/parivartan/tenders/${tenderId}/eligibility/suggest`, body),
  suggestReusableContent: (body) => api.post('/parivartan/knowledge/reusable/suggest', body),
  submitTechnicalSection: (tenderId, sectionId) =>
    api.post(`/parivartan/tenders/${tenderId}/technical-sections/${sectionId}/submit`),
  reviewTechnicalSection: (tenderId, sectionId, body) =>
    api.post(`/parivartan/tenders/${tenderId}/technical-sections/${sectionId}/review`, body),
  downloadTechnicalDocx: (tenderId) =>
    api.get(`/parivartan/tenders/${tenderId}/technical-response.docx`, { responseType: 'blob' }),

  getSubmission: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/submission`),
  approveSubmissionPack: (tenderId) => api.post(`/parivartan/tenders/${tenderId}/submission-approval`, {}),
  recordSubmission: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/submission`, body),
  getFinanceCase: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/finance`),
  saveFinanceRequirements: (tenderId, body) => api.put(`/parivartan/tenders/${tenderId}/finance`, body),
  recordFinancePayment: (tenderId, kind, body) => api.post(`/parivartan/tenders/${tenderId}/finance/${kind}/payments`, body),
  verifyFinance: (tenderId, kind, body) => api.post(`/parivartan/tenders/${tenderId}/finance/${kind}/verification`, body),
  recordSecurityRefund: (id, body) => api.post(`/parivartan/securities/${id}/refunds`, body),
  reviewSecuritySettlement: (id, body) => api.post(`/parivartan/securities/${id}/settlement`, body),
  getStaffing: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/staffing`),
  searchStaffing: (tenderId, params) => api.get(`/parivartan/tenders/${tenderId}/staffing/candidates`, { params }),
  saveRoleSlot: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/slots`, body),
  updateRoleSlot: (tenderId, slotId, body) => api.patch(`/parivartan/tenders/${tenderId}/staffing/slots/${slotId}`, body),
  selectRolePerson: (tenderId, slotId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/slots/${slotId}/selection`, body),
  saveStaffAssessment: (tenderId, proposalId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/proposals/${proposalId}/assessment`, body),
  submitTeam: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/submit`, body),
  decideTeam: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/decision`, body),
  recordStaffConsent: (tenderId, proposalId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/proposals/${proposalId}/consent`, body),
  reviewStaffConsent: (tenderId, proposalId) => api.post(`/parivartan/tenders/${tenderId}/staffing/proposals/${proposalId}/consent-review`, {}),
  overrideStaffConflict: (tenderId, proposalId, body) => api.post(`/parivartan/tenders/${tenderId}/staffing/proposals/${proposalId}/conflict-override`, body),
  transitionTender: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/lifecycle`, body),
  getWorkPackages: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/work-packages`),
  updateWorkPackage: (tenderId, packageId, body) => api.patch(`/parivartan/tenders/${tenderId}/work-packages/${packageId}`, body),
  getWorkPackagePolicy: () => api.get('/parivartan/work-packages/policy'),
  saveWorkPackagePolicy: (body) => api.put('/parivartan/work-packages/policy', body),
  addSubmissionClarification: (tenderId, body) =>
    api.post(`/parivartan/tenders/${tenderId}/submission/clarifications`, body),
  respondSubmissionClarification: (tenderId, index, body) =>
    api.post(`/parivartan/tenders/${tenderId}/submission/clarifications/${index}/respond`, body),
  getAward: (tenderId) => api.get(`/parivartan/tenders/${tenderId}/award`),
  createAward: (tenderId, body) => api.post(`/parivartan/tenders/${tenderId}/award`, body),

  reportPipeline: () => api.get('/parivartan/reports/pipeline'),
  reportWorkPackages: (params) => api.get('/parivartan/reports/work-packages', { params }),
  reportFeeEmd: () => api.get('/parivartan/reports/fee-emd'),
  reportTeam: () => api.get('/parivartan/reports/team'),
  reportDeadlines: () => api.get('/parivartan/reports/deadlines'),
  reportPendingApprovals: () => api.get('/parivartan/reports/pending-approvals'),
  reportCredentialExpiry: () => api.get('/parivartan/reports/credential-expiry'),
  reportEffortVariance: (params) => api.get('/parivartan/reports/effort-variance', { params }),
  reportWinLoss: () => api.get('/parivartan/reports/win-loss'),
  exportWinLossReport: () => api.get('/parivartan/reports/win-loss.csv', { responseType: 'blob' }),
  reportTimesheetStatus: () => api.get('/parivartan/reports/timesheets'),
  reportPersonnelAllocation: () => api.get('/parivartan/reports/personnel-allocation'),
  reportGoNoGo: () => api.get('/parivartan/reports/go-no-go'),
  reportCommercials: () => api.get('/parivartan/reports/commercials'),
  reportSubmissions: () => api.get('/parivartan/reports/submissions'),
  reportClientMix: () => api.get('/parivartan/reports/client-mix'),

  listAiSessions: (params) => api.get('/parivartan/ai/sessions', { params }),
  createAiSession: (body) => api.post('/parivartan/ai/sessions', body),
  askAi: (sessionId, question) => api.post(`/parivartan/ai/sessions/${sessionId}/ask`, { question }),
  draftFromReusable: (body) => api.post('/parivartan/ai/draft-from-reusable', body),
  classifyDocument: (id, body) => api.post(`/parivartan/documents/${id}/classify`, body),
  processDocument: (id) => api.post(`/parivartan/documents/${id}/process`),
  summariseDocument: (id) => api.post(`/parivartan/documents/${id}/summarise`),
  getDocumentProcessing: (id) => api.get(`/parivartan/documents/${id}/processing`),
  downloadParivartanDocument: (id) => api.get(`/parivartan/documents/${id}/download`, { responseType: 'blob' })
};

/** @deprecated Use platformAPI */
export const parivartanAPI = platformAPI;
